import usePurchasedEventAddonFeature from './hooks/usePurchasedEventAddonFeature';

export default usePurchasedEventAddonFeature;
